import React from 'react';

import { Modal } from '../modal/Modal.component';
import UI from '../ui';
import Utils from '../utils';
import withLayoutAndModalContexts from '../utils/withLayoutAndModalContexts';

const PdfViewer = ({ pdfUrls }) =>
	pdfUrls.map((url, index) => (
		<iframe
			title="Print Pdf Preview"
			key={index}
			src={url}
			width="100%"
			height="900"
		/>
	));

const { Link } = UI;
const { Session, Util } = Utils;

const PdfPreviewModal = ({ modalId, data: { pdfUrls = [] } }) => {
	const windowTitle = `Print Preview - ${pdfUrls.length} Labels`;

	const handleHelpLinkClick = () => {
		Util.openHelpCenter('20821477781147');
	};

	return (
		<Modal
			modalId={modalId}
			className="common-print pdf-preview-modal"
			header={windowTitle}
			hideFooter
		>
			{/* Print instructions */}
			<div className="print-instructions p-row">
				<div className="p-col-12 header">
					<strong>Print Instructions</strong>
				</div>
				<div className="p-col-12">
					<ol className="instructions-list">
						<li>
							Click <strong>Print</strong> to open the print in your browser
							print window.
						</li>
						<li>
							After selecting your printer, remember to set{' '}
							<strong>Paper Size</strong> to <strong>4" x 6"</strong>.
						</li>
					</ol>
				</div>
				<div className="help-container p-col-12">
					<span>Can't find it?&nbsp;</span>
					<Link
						onClick={handleHelpLinkClick}
						className="help-link"
						dataqa="pdf-preview-help-link"
					>
						Click here for help.
					</Link>
				</div>
			</div>

			{/* PdfViewer component */}
			<PdfViewer id="PdfViewer" pdfUrls={pdfUrls} />
		</Modal>
	);
};

export default withLayoutAndModalContexts(PdfPreviewModal);
